import React from 'react';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import Overlay from './components/Overlay/Overlay';
import styles from './App.module.scss';

export interface AppBlockerOverlayParams {
  isOpen: boolean;
}

const AppBlockerOverlay = (params: AppBlockerOverlayParams) => {
  const { isOpen } = params;
  return (
    <div>
      {isOpen && (
        <Overlay visible={isOpen}>
          <div className={styles.blockerOverlay}>
            <header>
              <Typography variant={'h1'}>
                Navi collection-team chrome extension not installed
              </Typography>
            </header>
            <div className={styles.content}>
              <Typography variant={'h3'}>
                Please use this{' '}
                <a
                  href="https://chrome.google.com/webstore/detail/web-whatsapp-plugin/pakmgmfjimfoncmcijpgkopindjokphj"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Link
                </a>{' '}
                to install the plugin
              </Typography>
            </div>
          </div>
        </Overlay>
      )}
    </div>
  );
};

export default AppBlockerOverlay;
